import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BasicChip } from '@/components/Chips/BasicChip';

import { useDcrFormContext } from '../_context/DcrFormContext';
import { useAddableFields } from '../_hooks/useAddableFields';
import { useTranslateLabel } from '../_hooks/useFieldLabel';
import { useSuggestedFields } from '../_hooks/useSuggestedFields';

import { addFieldsStyles as sx } from './AddFields.styles';
import { FieldPicker } from './FieldPicker';

export const AddFields = () => {
	const { t } = useTranslation();
	const translate = useTranslateLabel();
	const { disclosure } = useDcrFormContext();
	const addable = useAddableFields();
	const suggestions = useSuggestedFields();

	const [browseAllEl, setBrowseAllEl] = useState<HTMLButtonElement | null>(
		null
	);
	const [isPickerOpen, setIsPickerOpen] = useState(false);

	const suggestedEntries = suggestions.flatMap(key => {
		const entry = addable.find(item => item.key === key);
		return entry ? [entry] : [];
	});
	const pickerFields = addable.filter(({ key }) => !suggestions.includes(key));

	const handleAdd = (key: string) => {
		disclosure.add(key);
		setIsPickerOpen(false);
	};

	if (addable.length === 0) return null;

	return (
		<Box sx={sx.root}>
			<Box sx={sx.chipRow}>
				<Typography variant='body2' sx={sx.label}>
					{t('Add more fields')}
				</Typography>

				{suggestedEntries.map(({ key, def }) => (
					<BasicChip
						key={key}
						label={translate(def.label)}
						variant='secondary'
						customSx={sx.chip}
						onClick={() => handleAdd(key)}
					/>
				))}

				{pickerFields.length > 0 && (
					<Button
						ref={setBrowseAllEl}
						variant='text'
						size='small'
						sx={sx.browseAllLink}
						onClick={() => setIsPickerOpen(open => !open)}
					>
						{t('Browse all')}
					</Button>
				)}
			</Box>

			<FieldPicker
				open={isPickerOpen}
				anchorEl={browseAllEl}
				fields={pickerFields}
				onClose={() => setIsPickerOpen(false)}
				onSelect={handleAdd}
			/>
		</Box>
	);
};
